export const WHATSAPP_NUMBER = "5511971756644";

export function createWhatsAppLink(message = "Olá, preciso de um guincho em Arujá.") {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export function createLeadMessage({ nome, telefone, veiculo, local, servico, mensagem }) {
  return `Olá, sou ${nome || ""}.\n\nTelefone: ${telefone || ""}\nTipo de veículo: ${veiculo || ""}\n\nLocal: ${local || ""}\nServiço desejado: ${servico || ""}\n\nMensagem: ${mensagem || ""}`;
}